import {useQuery} from "@tanstack/react-query";
import * as api from "../../services/api";

export const useSummaryQuery = () => {
    return useQuery(
        ['summary'],
        async () =>  await api.Summary.getAll(),
        {
            // Keep the previous data when the query is loading to avoid the page
            // to unmount the content and show the circular progress.
            keepPreviousData: true,
            staleTime: 1000 * 60  // 1 minute
        }
    );
}